import { Layout, theme, Typography } from "antd";
import EditProfile from "../components/profile/EditProfile";

const { Content } = Layout;
const MyProfile = () => {
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  return (
    <Layout
      style={{
        marginLeft: 200,
      }}
    >
      <Content
        style={{
          margin: "24px 16px 0",
          overflow: "initial",
        }}
      >
        <div
          className="page-container"
          style={{
            background: colorBgContainer,
          }}
        >
          <Typography.Title level={5} className="titles-start">
            PROFİLİM
          </Typography.Title>
          <EditProfile />
        </div>
      </Content>
    </Layout>
  );
};

export default MyProfile;
